import { apiDate, optional, optionalApiDate, optionalBoolean, optionalString, zenum, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const WorkStatusSchema = zenum('notStarted', 'inProgress', 'needsRework', 'completed');
export type WorkStatus = ZodLessInfer<typeof WorkStatusSchema>;
export const workStatusRegexp = new RegExp(`^${WorkStatusSchema.options.join('|')}$`);

export const ProgressUpdateSchema = zodLess({
  status: optional(WorkStatusSchema),
  dueDate: optionalApiDate,
  neededAsap: optionalBoolean,
  updatedByUserId: optionalString,
  updatedAt: apiDate,
});

export type ProgressUpdate = ZodLessInfer<typeof ProgressUpdateSchema>;
